import { formatTimeToIST } from "@/utils/timezone";

import type { BreakView } from "./types";
import { closedByLabel, formatBreakLength } from "./format";

export const BreakList = ({
  breaks,
  emptyText = "No breaks yet.",
}: {
  breaks: BreakView[];
  emptyText?: string;
}) => {
  if (breaks.length === 0) {
    return (
      <p className="text-sm text-muted-foreground" data-testid="break-list-empty">
        {emptyText}
      </p>
    );
  }

  return (
    <ul className="flex flex-col divide-y" data-testid="break-list">
      {breaks.map((b, index) => {
        const note = closedByLabel(b);
        return (
          <li
            key={b._id}
            className="py-2 flex items-start justify-between gap-3 text-sm"
            data-testid="break-row"
          >
            <div className="flex flex-col">
              <span>
                <span className="text-muted-foreground mr-1">#{index + 1}</span>
                {formatTimeToIST(b.startedAt)} → {b.endedAt ? formatTimeToIST(b.endedAt) : "now"}
              </span>
              {(b.reason || note) && (
                <span className="text-xs text-muted-foreground">
                  {b.reason}
                  {b.reason && note ? " · " : ""}
                  {note}
                </span>
              )}
            </div>
            <span className="font-medium whitespace-nowrap" data-testid="break-duration">
              {formatBreakLength(b.durationSeconds)}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
